var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorplan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 70 70",
    viewBox: "0 0 70 70",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "51.2 38.5 52.7 37.1 48.2 32.2 48.2 19.4 16.2 19.4 16.2 51.4 48.2 51.4 48.2 41.6 46.2 41.6 46.2 49.4 32.4 49.4 32.4 45.7 30.4 45.7 30.4 49.4 18.2 49.4 18.2 35.1 30.4 35.1 30.4 39.3 32.4 39.3 32.4 33.1 18.2 33.1 18.2 21.4 46.2 21.4 46.2 26.6 40.2 26.6 40.2 28.6 46.2 28.6 46.2 32.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorplan);
export default __webpack_public_path__ + "static/media/floorplan.994e0eab1e964d67b4f5f0692f18afdf.svg";
export { ForwardRef as ReactComponent };